// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEmployeeContractMutationVariables = Types.Exact<{
  input: Types.UpdateEmployeeContractInput;
}>;

export type UpdateEmployeeContractMutation = { __typename?: 'Mutation' } & {
  updateEmployeeContract: { __typename?: 'EmployeeContractOutput' } & Pick<Types.EmployeeContractOutput, 'id'>;
};

export const UpdateEmployeeContractDocument = /*#__PURE__*/ gql`
    mutation updateEmployeeContract($input: UpdateEmployeeContractInput!) {
  updateEmployeeContract(input: $input) {
    id
  }
}
    `;
export type UpdateEmployeeContractMutationFn = Apollo.MutationFunction<
  UpdateEmployeeContractMutation,
  UpdateEmployeeContractMutationVariables
>;

/**
 * __useUpdateEmployeeContractMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeContractMutation, { data, loading, error }] = useUpdateEmployeeContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeContractMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeContractMutation, UpdateEmployeeContractMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmployeeContractMutation, UpdateEmployeeContractMutationVariables>(
    UpdateEmployeeContractDocument,
    options,
  );
}
export type UpdateEmployeeContractMutationHookResult = ReturnType<typeof useUpdateEmployeeContractMutation>;
export type UpdateEmployeeContractMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeContractMutation,
  UpdateEmployeeContractMutationVariables
>;
